import Vue from 'vue';
import Router from 'vue-router';
import VueCookie from 'vue-cookie';
import Layout from '@/components/Layout';
import Dashboard from '@/components/Dashboard';
import VegetativeOverview from '@/components/VegetativeOverview';
import Signup from '@/components/Signup';
import Signin from '@/components/Signin';
import Verify from '@/components/Verify';
import ForgotPassword from '@/components/ForgotPassword';
import ResetPassword from '@/components/ResetPassword';
import PlantBatchOverview from '@/components/PlantBatchOverview';
import PlantDetails from '@/components/PlantDetails';
import HarvestOverview from '@/components/HarvestOverview';
import HarvestDetails from '@/components/HarvestDetails';
import PlantBatchDetails from '@/components/PlantBatchDetails';
import PackageOverview from '@/components/PackageOverview';
import PackageDetails from '@/components/PackageDetails';
import FloweringOverview from '@/components/FloweringOverview';
import Profile from '@/components/Profile';
import Settings from '@/components/Settings';
import Reminder from '@/components/Reminder';

Vue.use(Router);
Vue.use(VueCookie);

const router = new Router({
  mode: 'history',
  routes: [
    {path: '/signup', name: 'Signup', component: Signup},
    {path: '/login', name: 'Signin', component: Signin},
    {path: '/forgot', name: 'ForgotPassword', component: ForgotPassword},
    {path: '/reset/:key', name: 'ResetPassword', component: ResetPassword},
    {path: '/verify/:key', name: 'Verify', component: Verify}, 
    {
      path: '/',
      name: 'Layout',
      component: Layout,
      meta: {title: 'Home', requiresSession: true},
      children: [
        {path: '/', name: 'Dashboard', component: Dashboard},
        {path: '/plantbatch', name: 'PlantBatches', component: PlantBatchOverview},
        {path: '/vegetative', name: 'VegetativeOverview', component: VegetativeOverview},
        {path: '/vegetative/details/:id', name: 'PlantDetails', component: PlantDetails},
        {path: '/flowering/details/:id', name: 'PlantDetails', component: PlantDetails},
        {path: '/plantbatch/details/:id', name: 'PlantBatchDetails', component: PlantBatchDetails},
        {path: '/harvests', name: 'HarvestOverview', component: HarvestOverview},
        {path: '/harvests/details/:id', name: 'HarvestDetails', component: HarvestDetails},
        {path: '/packages', name: 'PackagesOverview', component: PackageOverview},
        {path: '/packages/details/:id', name: 'PackageDetails', component: PackageDetails},
        {path: '/flowering', name: 'FloweringOverview', component: FloweringOverview},
        {path: '/profile', name: 'Profile', component: Profile},
        {path: '/settings', name: 'Settings', component: Settings },
        {path: '/reminder', name: 'Reminder', component: Reminder }
      ]
    }
  ]
});

router.beforeEach((to, from, next) => {
  const reqSession = to.matched.some(route => route.meta.requiresSession);
  const loggedIn = (typeof localStorage.token !== 'undefined') && Vue.cookie.get('PHPSESSID');
  const publicPages = ['/login', '/signup'];
  
  if (loggedIn && to.matched.some(record => publicPages.includes(record.path))) {
    return next('/');
  }

  if (!loggedIn && reqSession) {
    return next('/login');
  }

  next();
});

export default router;


// WEBPACK FOOTER //
// ./source/router/index.js